import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import { ActionWithPlayload } from '../../types';
import { LocalFlags } from './LocalFlags';
import { COLLAPSED_KEY } from './persistMigration';

export type { LocalFlags as LocalFlagsState };

type Action = ActionWithPlayload<ActionType.SET_LOCAL_FLAGS, LocalFlags>;

export const initialState: LocalFlags = {
  // we keep local storage in init state only here, because migrations
  // are not applied to case where redux-persist never existed
  isLegendCollapsed: !!window.localStorage.getItem(COLLAPSED_KEY),
};

const variablesReducer: Reducer<LocalFlags, Action> = (
  state: LocalFlags = initialState,
  action: Action,
) => {
  switch (action.type) {
    case ActionType.SET_LOCAL_FLAGS:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default variablesReducer;
